export default __webpack_public_path__ + "static/media/weather.41709da0.svg";